import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



const cardData = {
  keyword: "Online Cab Booking Pune",
  heading: "Lotus Cab: Online Cab Booking Pune",

  headingDescription:
    "Lotus Cab provides fast and reliable online cab booking in Pune for local travel, airport transfers, corporate rides, family trips, and outstation journeys. With just a few clicks, you can book AC sedans, SUVs, Innova Crysta, Swift Dzire, Urbania vans, or even mini buses for group travel. Our online platform ensures instant confirmation, transparent fare details, and flexible one-way or round-trip options. All vehicles are well-maintained, sanitized, and driven by professional chauffeurs trained for safe city and highway driving. Whether you need a same-day booking, weekend trip taxi, or corporate transport solution, we make the entire process quick and hassle-free. With 24/7 customer support and secure booking assistance, Lotus Cab ensures smooth travel planning across Pune.",

  top: "Top Places to Visit in Pune with Online Cab Booking",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is Pune’s most famous historical landmark and a symbol of Maratha heritage. Tourists frequently book online cabs to visit this centrally located fort without worrying about parking or traffic. AC sedans provide comfortable city travel. Online booking ensures timely pickup and flexible waiting time for sightseeing."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a peaceful historical monument surrounded by beautiful gardens. Families and school groups often book online taxis for educational visits. Comfortable AC travel enhances the experience."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend trekking destination near Pune. SUV online booking is ideal for smooth hill-road travel and safe return journeys."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "One of Pune’s most visited temples, Dagdusheth Temple attracts daily devotees. Online taxi booking helps avoid city traffic stress."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "A scenic picnic spot near Pune perfect for family outings. Round-trip online cab booking makes weekend plans easy."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a picturesque hill destination near Pune. Outstation online booking ensures smooth highway travel."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a favorite expressway getaway. AC SUVs provide comfortable weekend travel."
    },
    {
      title: "Pune Airport",
      description:
        "Online airport cab booking guarantees punctual pickup and drop with flight tracking support."
    }
  ],

  services: [
    {
      name: "Online Cab Pune",
      description:
        "Lotus Cab offers convenient online cab booking in Pune for city rides, airport transfers, and outstation trips. Choose from sedan, SUV, Innova, or Urbania options. Transparent pricing and instant confirmation provided. Professional drivers ensure safe and punctual service."
    },
    {
      name: "AC Cab Online Booking Pune",
      description:
        "Book air-conditioned cabs online for comfortable travel in all seasons. Ideal for city commutes and airport transfers."
    },
    {
      name: "Sedan Cab Online Booking Pune",
      description:
        "Affordable sedan booking including Swift Dzire and premium sedans for smooth and economical travel."
    },
    {
      name: "SUV Cab Online Pune",
      description:
        "Spacious SUV online booking ideal for family trips, group travel, and long-distance journeys."
    },
    {
      name: "Airport Pickup Cab Online Pune",
      description:
        "Reliable online airport taxi booking with punctual pickup and luggage assistance."
    },
    {
      name: "Outstation Cab Online Pune",
      description:
        "Comfortable outstation cab booking for Mumbai, Nashik, Mahabaleshwar, Hyderabad, and more."
    },
    {
      name: "Corporate Online Cab Pune",
      description:
        "Professional online cab solutions for business meetings and employee transportation."
    },
    {
      name: "Mini Bus Online Booking Pune",
      description:
        "Group travel online booking for weddings, corporate outings, and school trips."
    }
  ],

  tableData: [
    ["Online Cab Pune", "Book Cab Online Pune"],
    ["Internet Taxi Booking Pune", "Pune Online Taxi Service"],
    ["AC Cab Online Booking Pune", "Sedan Cab Online Booking Pune"],
    ["SUV Cab Online Pune", "Luxury Cab Online Pune"],
    ["Airport Pickup Cab Online Pune", "Outstation Cab Online Pune"],
    ["Corporate Online Cab Pune", "Family Trip Cab Online Pune"],
    ["Mini Bus Online Booking Pune", "Innova Crysta Online Booking Pune"],
    ["Swift Dzire Online Booking Pune", "Online Taxi Fare Pune"],
    ["Same Day Online Cab Pune", "Weekend Trip Online Cab Pune"],
    ["Online Taxi for Pune Airport", "Urbania Online Cab Booking Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Instant Online Confirmation",
      WhyChoosedescription:
        "Get immediate booking confirmation with transparent fare details."
    },
    {
      WhyChooseheading: "Wide Vehicle Options",
      WhyChoosedescription:
        "Choose from sedan, SUV, Innova Crysta, Urbania, and mini bus options."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per km rate with no hidden charges."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription:
        "Experienced and background-verified chauffeurs for safe travel."
    },
    {
      WhyChooseheading: "Airport & Outstation Expertise",
      WhyChoosedescription:
        "Reliable airport transfer and long-distance taxi services."
    },
    {
      WhyChooseheading: "Corporate Travel Support",
      WhyChoosedescription:
        "Dedicated cab solutions for companies and business clients."
    },
    {
      WhyChooseheading: "Family & Group Friendly",
      WhyChoosedescription:
        "Spacious and comfortable vehicles for family and group trips."
    },
    {
      WhyChooseheading: "24/7 Customer Assistance",
      WhyChoosedescription:
        "Round-the-clock booking and travel support."
    }
  ]
};

const faqData = [
  { question: "How do I book a cab online in Pune?", answer: "You can book online via website or contact support for instant confirmation." },
  { question: "Is online airport cab booking available?", answer: "Yes, 24/7 airport taxi booking is available online." },
  { question: "Are luxury vehicles available online?", answer: "Yes, premium and luxury vehicles can be booked online." },
  { question: "Is outstation booking available online?", answer: "Yes, online outstation cab booking is available." },
  { question: "Is fare shown before confirmation?", answer: "Yes, transparent fare details are provided before booking." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Is same-day booking possible?", answer: "Yes, same-day online cab booking is available." },
  { question: "Is corporate booking available online?", answer: "Yes, corporate cab booking options are available." },
  { question: "Are drivers experienced?", answer: "Yes, professional chauffeurs ensure safe travel." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer support is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "Online booking was quick and easy. Cab arrived on time and fare was transparent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "Booked airport cab online. Smooth ride and professional driver. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable online cab service for our office travel needs. Very convenient booking process.",
    rating: 5
  }
];























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Pune",
  "image": "https://lotuscab.com/assets/images/online-cab-booking-pune.jpg", 
  "description": "Lotus Cab provides convenient online cab booking in Pune for AC, sedan, SUV, and luxury cabs. Services include airport pickups, outstation travel, corporate trips, family trips, weekend trips, Mini Bus, Innova Crysta, Swift Dzire, and Urbania. Enjoy same-day cab service, transparent fares, and hassle-free online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/online-cab-booking-pune"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Online Cab Booking Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book cabs online in Pune with Lotus Cab. AC, sedan, SUV, luxury cabs, airport pickups, outstation trips, corporate & family travel. Mini Bus, Innova Crysta, Swift Dzire, Urbania available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Online Cab Pune, Book Cab Online Pune, Internet Taxi Booking Pune, Pune Online Taxi Service, AC Cab Online Booking Pune, Sedan Cab Online Booking Pune, SUV Cab Online Pune, Luxury Cab Online Pune, Airport Pickup Cab Online Pune, Outstation Cab Online Pune, Corporate Online Cab Pune, Family Trip Cab Online Pune, Mini Bus Online Booking Pune, Innova Crysta Online Booking Pune, Swift Dzire Online Booking Pune, Online Taxi Fare Pune, Same Day Online Cab Pune, Weekend Trip Online Cab Pune, Online Taxi for Pune Airport, Urbania Online Cab Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingpune;